import { useEffect, useMemo, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SecondarySidebar } from '../shared/components/SecondarySidebar/SecondarySidebar';
import { Preferences } from './Preferences/Preferences';
import { Subscriptions } from './Subscriptions/Subscriptions';
import { userService } from '../auth/services/user.service';
import { createRecipientObjectForUser } from './ManageRecipients/Utils';
import { Recipient } from './ManageRecipients/interface';
import {
  recipientAlertService,
  AlertsAPIservice,
  userAlertsService
} from './APIServices/APIServiceContext';
import { NotificationsHeader } from './NotificationsHeader';

export default function Notifications() {
  const [activeRecipient, setActiveRecipient] = useState<Recipient>();
  const loggedInUser = userService.getUser();
  const switchRecipient = (recipient: Recipient) => {
    if (!recipient) {
      return;
    }
    setActiveRecipient({ ...recipient });
    recipientAlertService.setRecipient(recipient);
  };

  useEffect(() => {
    if (loggedInUser) {
      setActiveRecipient(createRecipientObjectForUser(loggedInUser));
    }
  }, []);

  return (
    <>
      <NotificationsHeader activeRecipient={activeRecipient} switchRecipient={switchRecipient} />

      <AlertsAPIservice.Provider
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value={{
          APIService:
            activeRecipient?.channel_type === 'user' ? userAlertsService : recipientAlertService,
          activeRecipientID: activeRecipient?.id
        }}
      >
        <NotificationsInner />
      </AlertsAPIservice.Provider>
    </>
  );
}

export function NotificationsInner() {
  const tabs = useMemo(() => {
    return [
      {
        label: 'Subscriptions',
        route: '/subscriptions',
        path: `subscriptions`,
        Component: Subscriptions,
        icon: 'checklist',
        shortcut: ''
      },
      {
        label: 'Alert Preferences',
        route: '/preferences',
        path: `preferences`,
        Component: Preferences,
        icon: 'preferences',
        shortcut: ''
      }
    ];
  }, []);

  return (
    <div className='main-content-area'>
      <div className='d-flex h-100'>
        <SecondarySidebar tabs={tabs} topSpacing={5} />

        <div className='main-content-wrapper flex-1'>
          <div className='main-content-area'>
            <Routes>
              {tabs.map(tab => {
                const TabComponent = tab.Component;
                return <Route key={tab.label} path={tab.route} element={<TabComponent />} />;
              })}
              <Route path='*' element={<Navigate to='subscriptions' replace />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
}
